module.exports = __webpack_public_path__ + "static/media/b2b-overview.0290afc4.jpg";